"use client";

import React from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { BsSearch } from "react-icons/bs";

const ThemeSearchInput = ({ className, setSearchQuery }) => {
  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  return (
    <div className={`theme-search-input ${className}`}>
      <Controller
        control={control}
        name="searchText"
        render={({ field }) => (
          <Form.Control
            type="search"
            placeholder="Search here..."
            aria-label="Search"
            className="form-input"
            onChange={(e) => {
              console.log("first input");
              setSearchQuery(e.target.value);
              field.onChange(e);
            }}
            value={field.value || ""} 
          />
        )}
      />

      <BsSearch color="black" className="search-icon" />
    </div>
  );
};

export default ThemeSearchInput;
